export default "__VITE_ASSET__DF1OEyT9__"